// Environment-based theme configuration
const getEnvironmentTheme = () => {
  const env = process.env.REACT_APP_BACKEND_ENV;
  
  // Base colors that remain consistent across environments
  const baseColors = {
    white: '#ffffff',
    black: '#000000',
    gray: '#cccccc',
    lightGray: '#f8f8f8',
    darkGray: '#666666',
  };

  // Environment-specific color schemes
  const environmentColors = {
    // Production - Standard blue theme
    Production: {
      primary: '#2f5d96', // JMI Blue
      primaryHover: '#264a78',
      primaryDark: '#315382',
      primaryLight: '#2f89d9',
      secondary: '#6fbe48', // JMI Green
      accent: '#f44336', // JMI Red
      accentHover: '#d2190b',
      accentRaw: '244, 67, 54',
    },
    
    // Staging - Orange theme to clearly distinguish from production
    Staging: {
      primary: '#ff8c00', // Dark Orange
      primaryHover: '#e67e00',
      primaryDark: '#d67600',
      primaryLight: '#ffa726',
      secondary: '#ff9800', // Orange
      accent: '#f44336', // Keep red for errors
      accentHover: '#d2190b',
      accentRaw: '244, 67, 54',
    },
    
    // Development - Purple theme
    Development: {
      primary: '#9c27b0', // Purple
      primaryHover: '#7b1fa2',
      primaryDark: '#6a1b9a',
      primaryLight: '#ba68c8',
      secondary: '#e91e63', // Pink
      accent: '#f44336', // Keep red for errors
      accentHover: '#d2190b',
      accentRaw: '244, 67, 54',
    },
    
    // Local - Teal theme
    local: {
      primary: '#009688', // Teal
      primaryHover: '#00796b',
      primaryDark: '#00695c',
      primaryLight: '#4db6ac',
      secondary: '#00bcd4', // Cyan
      accent: '#f44336', // Keep red for errors
      accentHover: '#d2190b',
      accentRaw: '244, 67, 54',
    },
    
    // Ngrok - Red theme
    ngrok: {
      primary: '#d32f2f', // Red
      primaryHover: '#b71c1c',
      primaryDark: '#c62828',
      primaryLight: '#ef5350',
      secondary: '#ff5722', // Deep Orange
      accent: '#f44336', // Keep red for errors
      accentHover: '#d2190b',
      accentRaw: '244, 67, 54',
    },
  };

  // Default to Production if environment not found
  const colors = environmentColors[env] || environmentColors.Production;
  
  return {
    ...baseColors,
    ...colors,
    environment: env,
    isStaging: env === 'Staging',
    isDevelopment: env === 'Development',
    isLocal: env === 'local',
    isNgrok: env === 'ngrok',
    isProduction: env === 'Production',
  };
};

export default getEnvironmentTheme; 